import {Component, Event, EventEmitter, h, Prop, State} from '@stencil/core';
import {StarchTicketCreateResponse} from "../../interfaces/starch-ticket-create-response";

declare var window: {CodCat: string}

@Component({
    tag: 'starch-ticket-form',
    styleUrl: './starch-ticket-form.css'
})
export class StarchTicketForm {

    @Prop() email: string;
    @Prop() name: string;
    @Prop() userType: string;
    @Prop() city: string;
    @Prop() phone: string;
    @Prop() application: string;
    @Prop() layout: 'starch' | 'standard';
    @State() codCat: string;

    @Prop() showMessagePages: boolean = true;

    @Event() onTicketSent: EventEmitter<StarchTicketCreateResponse>;
    @Event() onTicketError: EventEmitter<string>;

    constructor() {
        if (!this.codCat) {
            this.codCat = window.CodCat;
        }
        console.log('codCat', this.codCat);
    }

    render() {
        return (
            <starch-base-ticket-form
                layout={this.layout}
                email={this.email}
                name={this.name}
                user-type={this.userType}
                city={this.city}
                phone={this.phone}
                application={this.application}
                codCat={this.codCat}
                show-message-pages={this.showMessagePages}
                onTicketSent={(ev) => this.onTicketSent.emit(ev.detail)}
                onTicketError={(ev) => this.onTicketError.emit(ev.detail)}
            />
        );
    }
}
